import Vue from "vue";
import $ from "jquery";
import directive from './directive';
import hljs from 'highlight.js';
// 样式文件
import('highlight.js/styles/atom-one-light.css');

/**
 * 设置宽度 v-width="{offsetWidth:300}"  v-width="300"
 */
Vue.directive('width',function(el,binding){
  let w = 0;
  if(binding.value.offsetWidth){
    w = binding.value.offsetWidth;
  }
  let windowWidth = $(window).width();
  let left = el.offsetLeft;
  let width = windowWidth - left - w;
  el.style.width = width + "px";
  window.onresize = function() {
    let w = 0;
    if(binding.value.offsetWidth){
      w = binding.value.offsetWidth;
    }
    let windowWidth = $(window).width();
    let left = el.offsetLeft;
    let width = windowWidth - left - w;
    el.style.width = width + "px";
  }
});

/**
 * 设置高度 v-height="{offsetHeight:300}"  v-height="300"
 */
Vue.directive('height', function(el, binding){
  let h = 0;
  if(binding.value.offsetHeight){
    h = binding.value.offsetHeight;
  }
  let windowHeight = $(window).height();

  let top = el.offsetTop;
  let height = windowHeight - top - h;
  el.style.height = height+"px";

  window.onresize = function() {
    let h = 0;
    if(binding.value.offsetHeight){
      h = binding.value.offsetHeight;
    }
    let windowHeight = $(window).height();

    let top = el.offsetTop;
    let height = windowHeight - top - h;
    el.style.height = height+"px";
  };
});

/**
 * 高亮
 */
Vue.directive('highlight', {
  deep: true,
  // 先有数据再绑定
  bind: function (el, binding) {
    // on first bind, highlight all targets
    let targets = el.querySelectorAll('pre code');
    targets.forEach((target) => {
      // if a value is directly assigned to the directive, use this
      // instead of the element content.
      if (binding.value) {
        target.textContent = binding.value
      }
      hljs.highlightBlock(target)
    })
  },
  // 先绑定，后面会有数据更新
  componentUpdated: function (el, binding) {
    // after an update, re-fill the content and then highlight
    let targets = el.querySelectorAll('pre code');
    targets.forEach((target) => {
      if (binding.value) {
        target.textContent = binding.value;
        hljs.highlightBlock(target)
      }
    })
  }
});

/**
 * 设置v-clickoutside,点击除下拉框任何位置，触发事件，一般用于下拉框消失 v-clickoutside='handleClose'
 */
Vue.directive('clickoutside',{
  bind:function(el,binding,vnode){
    function documentHandler(e){
      if(el.contains(e.target)){
        return false;
      }
      if(binding.expression){
        binding.value(e)
      }
    }
    el._vueClickOutside_ = documentHandler;
    document.addEventListener('click',documentHandler);
  },
  unbind:function(el,binding){
    document.removeEventListener('click',el._vueClickOutside_);
    delete el._vueClickOutside_;
  }
});

/**
 * 拖拽指令 v-draggable="options"
 * options = {
 *  trigger: /这里传入作为拖拽触发器的CSS选择器/,
 *  body:    /这里传入需要移动容器的CSS选择器/,
 *  recover: /拖动结束之后是否恢复到原来的位置/
 * }
 */
Vue.directive('draggable',directive.draggable);

/**
 * clipboard指令 v-draggable="options"
 * options = {
 *  value:    /在输入框中使用v-model绑定的值/,
 *  success:  /复制成功后的回调/,
 *  error:    /复制失败后的回调/
 * }
 */
Vue.directive('clipboard', directive.clipboard);

